import React, { useState, useRef } from 'react'
import PageLayout from '@layouts/PageLayout'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { Input, Table, Dropdown, Popconfirm, message, Space } from 'antd'
import Fetch from '@components/CRUD/Fetch'
import { EllipsisOutlined } from '@ant-design/icons'
import Create from './Create'
import { client } from '@utils/client'
import Edit from './Edit'
import Button from '@components/Button'
import Text from '@components/Text'

const List = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const [modalCreateOpen, setmodalCreateOpen] = useState(false)
  const [keyword, setKeyword] = useState()
  const [modalEditOpen, setModalEditOpen] = useState(false)
  const [defaultValues, setDefaultValues] = useState({})

  const fetch = async ({ page, pageSize, keyword }) => {
    const result = await client
      .get('/activity', {
        params: {
          page: page,
          limit: pageSize,
          keyword: keyword,
          order: {
            order: 1,
          },
        },
      })
      .then((res) => res.data)

    return result
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'order',
      key: 'order',
      width: 75,
    },
    {
      title: t('promotion.list.bannerImage'),
      dataIndex: 'bannerImage',
      key: 'bannerImage',
      width: 122,
      render: function bannerImageUrl(text) {
        return <img src={text} alt={text} width={76} />
      },
    },
    {
      title: 'แท็ก',
      dataIndex: 'tag',
      key: 'tag',
      width: 75,
    },
    {
      title: 'url',
      dataIndex: 'url',
      key: 'url',
      width: 75,
    },
    {
      title: '',
      key: 'edit',
      width: 61,
      render: function shopEvent(record) {
        const items = [
          {
            key: '1',
            label: (
              <a
                onClick={() => {
                  setModalEditOpen(true)
                  setDefaultValues(record)
                }}
              >
                <Text type="primary">{t('promotion.list.edit')}</Text>
              </a>
            ),
          },
          {
            type: 'divider',
          },
          {
            key: '2',
            label: (
              <div>
                <Popconfirm
                  placement="left"
                  title={t('promotion.list.deleteConfirmQuestion')}
                  okText={t('promotion.list.okText')}
                  cancelText={t('promotion.list.cancelText')}
                  onConfirm={() => onDelete(record.id)}
                >
                  <a href="#">
                    <Space
                      style={{
                        width: '100%',
                        color: '#56B9C3',
                        justifyContent: 'center',
                      }}
                      type="primary"
                    >
                      {t('promotion.list.delete')}
                    </Space>
                  </a>
                </Popconfirm>
              </div>
            ),
          },
        ]
        return (
          <>
            <div>
              <Dropdown
                menu={{
                  items,
                }}
                trigger="click"
              >
                <EllipsisOutlined
                  style={{ fontSize: '32px', color: '#005596' }}
                />
              </Dropdown>
            </div>
          </>
        )
      },
    },
  ]
  const handleReload = () => {
    fetchRef.current.reload()
  }
  const onDelete = async (id) => {
    try {
      await client.delete(`/activity/${id}`)
      message.success(t('promotion.list.deleteSuccess'))
      handleReload()
    } catch (e) {
      message.error(t('promotion.list.deleteeFailed'))
    }
  }
  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const style = {
    btnAddData: { borderRadius: '5px', width: '165px', height: '40px' },
    divSearch: {
      width: '100%',
      display: 'flex',
      gap: '20px',
      marginBottom: '20px',
    },
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Fetch fetch={fetch} params={{ page, pageSize, keyword }} ref={fetchRef}>
        {({ data, total }) => (
          <>
            <PageLayout
              title="กิจกรรม"
              shownBack={false}
              extra={[
                <Button
                  type="primary"
                  key="modalCreate"
                  iconAddData
                  onClick={() => setmodalCreateOpen(true)}
                  style={style.btnAddData}
                >
                  {t('promotion.list.addData')}
                </Button>,
              ]}
            >
              <div style={style.divSearch}>
                <SearchInput fetchData={(keyword) => setKeyword(keyword)} />
              </div>

              <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                onChange={handleChange}
                pagination={{
                  defaultCurrent: defaultPageSize,
                  defaultPageSize: defaultPageSize,
                  current: page,
                  pageSize,
                  total,
                }}
              ></Table>
            </PageLayout>
          </>
        )}
      </Fetch>

      <Create
        modalCreateOpen={modalCreateOpen}
        setmodalCreateOpen={setmodalCreateOpen}
      />
      <Edit
        modalEditOpen={modalEditOpen}
        setModalEditOpen={setModalEditOpen}
        defaultValues={defaultValues}
      />
    </>
  )
}
const SearchInput = ({ fetchData }) => {
  const { t } = useLocalization()
  const [keyword, setKeyword] = useState()
  const style = {
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Input
        defaultValue={keyword}
        placeholder=""
        style={style.inputSearch}
        onChange={(e) => setKeyword(e.target.value)}
      />

      <Button
        style={style.btnSearch}
        type="primary"
        key="reload"
        onClick={() => fetchData(keyword)}
      >
        {t('promotion.list.search')}
      </Button>
    </>
  )
}

SearchInput.propTypes = {
  fetchData: PropTypes.func,
}
export default List
